import React from 'react';
import Validate from '../../../validate/Validate';

export default props => (
    <Validate
        validate={state => {
            if (!state.connections.listed.find(con => con.id == props.match.params.userId)) {
                throw new Error('Connection ' + props.match.params.userId + ' not found');
            }
        }}>
        {props.children}
    </Validate>
);
